import { DialogContent } from "@material-ui/core";
import { SarsModel } from "../../../../domain/SarsModel";
import { DialogDeciderActionTypes } from "../../../../domain/TransferRecord";
import { CreateFoiDialog } from "./CreateFoiDialog";

export const CreateDecider: React.FC<{
  item: SarsModel;
  action: DialogDeciderActionTypes;
}> = ({ item, action }) => {
  let renderCreateActionDialog;
  switch (action) {
    case DialogDeciderActionTypes.FOI:
      renderCreateActionDialog = <CreateFoiDialog item={item}/>;
      break;
    default:
      renderCreateActionDialog = (
        <DialogContent>Create Dialog action not supported</DialogContent>
      );
  }

  return renderCreateActionDialog;
};
